export default {
    erklaerungsText: state => state.erklaerungsText,
    arzneimittelvorschlaege: state => state.arzneimittelvorschlaege
}